import {
  GET_SURVEYS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/surveys/get'
import type { SurveyListParams, SurveyListResult } from 'app/common/types/surveys'
import type { CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import { useSurveyData } from './useSurveyData'

const defaultState: SurveyListResult = {
  items: [],
  total: 0,
}

type Options = CommonDataOptions<SurveyListResult, SurveyListParams>

export const useSurveys = (options: Options) => {
  const res = useSurveyData({
    ...options,
    requestValue: GET_SURVEYS,
    error: 'Не удалось получить список опросов',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
